import { computed, ComputedRef } from 'vue';
import {
    JointCanvasTemplateConfiguration,
    JointPivotGlobalConfiguration,
} from '@/modules/ConfiguratorJoints/types/canvasTemplate';

const emptyJointPivotGlobalConfiguration: JointPivotGlobalConfiguration = {
    pivotX: 0,
    pivotY: 0,
    leftCornerX: 0,
    rightCornerX: 0,
    leftCornerY: 0,
    rightCornerY: 0,
    arcAnchorX: 0,
    arcAnchorY: 0,
    arcAnchorXTypeOne: 0,
    arcAnchorYTypeOne: 0,
    rightArmLocalOriginX: 0,
    rightArmLocalOriginY: 0,
    regularGuideOneLeftArmX: 0,
    regularGuideOneLeftArmY: 0,
    regularGuideOneLeftArmRotation: 0,
    regularGuideTwoLeftArmX: 0,
    regularGuideTwoLeftArmY: 0,
    regularGuideTwoLeftArmRotation: 0,
    regularGuideOneRightArmX: 0,
    regularGuideOneRightArmY: 0,
    regularGuideOneRightArmRotation: 0,
    regularGuideTwoRightArmX: 0,
    regularGuideTwoRightArmY: 0,
    regularGuideTwoRightArmRotation: 0,
    wireGuideOneLeftArmX: 0,
    wireGuideOneLeftArmY: 0,
    wireGuideOneLeftArmRotation: 0,
    wireGuideTwoLeftArmX: 0,
    wireGuideTwoLeftArmY: 0,
    wireGuideTwoLeftArmRotation: 0,
    wireGuideOneRightArmX: 0,
    wireGuideOneRightArmY: 0,
    wireGuideOneRightArmRotation: 0,
    wireGuideTwoRightArmX: 0,
    wireGuideTwoRightArmY: 0,
    wireGuideTwoRightArmRotation: 0,
    inoxGuideOneLeftArmX: 0,
    inoxGuideOneLeftArmY: 0,
    inoxGuideOneLeftArmRotation: 0,
    inoxGuideTwoLeftArmX: 0,
    inoxGuideTwoLeftArmY: 0,
    inoxGuideTwoLeftArmRotation: 0,
    inoxGuideOneRightArmX: 0,
    inoxGuideOneRightArmY: 0,
    inoxGuideOneRightArmRotation: 0,
    inoxGuideTwoRightArmX: 0,
    inoxGuideTwoRightArmY: 0,
    inoxGuideTwoRightArmRotation: 0,
    concealedGuideOneLeftArmX: 0,
    concealedGuideOneLeftArmY: 0,
    concealedGuideOneLeftArmRotation: 0,
    concealedGuideTwoLeftArmX: 0,
    concealedGuideTwoLeftArmY: 0,
    concealedGuideTwoLeftArmRotation: 0,
    concealedGuideOneRightArmX: 0,
    concealedGuideOneRightArmY: 0,
    concealedGuideOneRightArmRotation: 0,
    concealedGuideTwoRightArmX: 0,
    concealedGuideTwoRightArmY: 0,
    concealedGuideTwoRightArmRotation: 0,
    slatConnectorX: 0,
    slatConnectorY: 0,
    slatConnectorWidthMm: 0,
    slatConnectorHeightMm: 0,
    slatConnectorRotation: 0,
    slatConnectorScale: 1,
};

export function useActivePivotGlobalConfiguration(
    activeTemplate: ComputedRef<JointCanvasTemplateConfiguration | null>,
) {
    return computed<JointPivotGlobalConfiguration>(
        () => activeTemplate.value?.pivotGlobalConfiguration ?? emptyJointPivotGlobalConfiguration,
    );
}
